<template>
  <div :style="{ background: swiechColor }" style="height: 7vh; width: 100%">
    <Row class-name="headWrap">
      <Col span="9" class-name="mediaheadLeft">
        <span></span>
        <!-- <Button v-if="!sun.btn" size='small' class="headReturn cell poptip--bottom" aria-controls="返回至首页" to='/home'>
                    <img :src="btnIcon" alt="返回" style="vertical-align: sub;">
                    <span style="margin-left: 0.4vw">返回</span>
                </Button> -->

        <!-- <el-switch v-model="switchBD" active-text="开启北斗网格码" inactive-text="关闭北斗网格码">
        </el-switch> -->
        <!-- <el-checkbox @change="changeVal" size="mini" v-model="switchBD" label="北斗网格码" border></el-checkbox> -->
        <div class="flex">
          <Time />
        </div>
        <div></div>
      </Col>
      <Col span="6" class-name="titleBox flex align-end justify-center ">
        <div>
          {{ sun.title }}
        </div>
      </Col>
      <Col span="9" class-name="mediaheadRight">
        <div class="timeLineBox">
          <div class="timeLineMain">
            <div class="leftArrow" @click="clickLeft"></div>
            <div class="mainLine">
              <div
                class="circularDots"
                :class="typeValue == 1 ? 'circularDotsActive' : ''"
                @click="changeValue(1)"
              >
                <div class="valueLabel">近三日</div>
              </div>
              <div
                class="circularDots"
                :class="typeValue == 2 ? 'circularDotsActive' : ''"
                @click="changeValue(2)"
              >
                <div class="valueLabel">近一周</div>
              </div>
              <div
                class="circularDots"
                :class="typeValue == 3 ? 'circularDotsActive' : ''"
                @click="changeValue(3)"
              >
                <div class="valueLabel">近俩周</div>
              </div>
              <div
                class="circularDots"
                :class="typeValue == 4 ? 'circularDotsActive' : ''"
                @click="changeValue(4)"
              >
                <div class="valueLabel">近一个月</div>
              </div>
            </div>
            <div class="rightArrow" @click="clickRight"></div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import Time from "@/components/time";
export default {
  name: "data-header",
  props: {
    headerData: Object,
    sun: {
      typeof: Object,
      default: {
        title: String,
      },
    },
    swiechColor: {
      typeof: String,
    },
  },
  components: {
    Time,
  },
  data() {
    return {
      typeValue: 1,
      btnIcon: require("../../assets/dataScreen/return.png"),
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
      switchBD:true
    };
  },
  methods: {
    changeVal(val){
        this.$bus.$emit("grid-change", val);
    },
    changeValue(value) {
      this.typeValue = value;
      this.$emit("child-change", value);
    },
    clickLeft() {
      if (this.typeValue > 1) {
        this.typeValue--;
        this.changeValue(this.typeValue);
      }
    },
    clickRight() {
      if (this.typeValue < 5) {
        this.typeValue++;
        this.changeValue(this.typeValue);
      }
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.headWrap {
  background: url("../../assets/dataScreen/head.png") no-repeat; // no-repeat top center / cover
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  padding: 0 1%;
  color: white;

  .spanAfter {
    margin-left: 0.5vw;
  }

  .titleBox {
    font-size: 1.8vw;
    letter-spacing: 1px;
    color: white;
    font-weight: bold;
    background: linear-gradient(75deg, #21f1c2, #66fdf1, #1ebcea);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .timeLineBox {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: end;
    padding-bottom: 7px;
    box-sizing: border-box;
    .timeLineMain {
      width: 100%;
      height: 2.8vh;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .leftArrow {
        width: 20px;
        height: 20px;
        background: url("../../assets/dataScreen/left.png") center center no-repeat;
        background-size: 100% 100%;
        margin-top: 12px;
        margin-right: 10px;
        cursor: pointer;
      }
      .rightArrow {
        width: 20px;
        height: 20px;
        background: url("../../assets/dataScreen/right.png") center center no-repeat;
        background-size: 100% 100%;
        margin-top: 12px;
        margin-left: 10px;
        cursor: pointer;
      }
      .mainLine {
        width: 88%;
        height: 2px;
        background: #63b5c0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .circularDots {
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 50%;
          position: relative;
          cursor: pointer;
          .valueLabel {
            position: absolute;
            left: 50%;
            bottom: -20px;
            transform: translateX(-50%);
            font-size: 12px;
            color: #ffffff;
            white-space: nowrap;
            // color: #53D9FF;
          }
        }
        .circularDotsActive {
          width: 12px;
          height: 12px;
          background: #53d9ff;
          border: 1px solid #63b5c0;
          box-sizing: border-box;
          .valueLabel {
            color: #53d9ff;
          }
        }
      }
    }
  }
}
</style>
